import React, { useState, useRef, useEffect } from 'react';

// components
import PillButton from '../PillButton/PillButton';
import PillDropdown from '../PillDropdown/PillDropdown';

// media
import searchIconImg from '../../media/search-icon.svg';

function PropertySearch(props) {
    const searchInput = useRef(null);

    // TODO: use outputs of input elements to generate a dynamic url with the search filters embeded (interpreted by the useSearchedProperties hook)

    return (
        <div className="h-8 mt-4 mb-8 flex justify-center items-center space-x-2">
            <PillDropdown>Price</PillDropdown>
            <PillDropdown>For Sale</PillDropdown>
            <div className="min-w-1/4 text-mid-grey">
                <div className="relative z-0 transition-all">
                    <div className="relative flex pointer-events-none justify-between py-2 px-3 z-20">
                        <img className="pointer-events-none w-6 ml-2 mr-4 pr-2 opacity-[65%]" src={searchIconImg} alt="Search properties to buy or rent" onClick={() => searchInput.current && searchInput.current.focus()} />
                        <PillButton size="sm" className="">Search</PillButton>
                    </div>
                    <input className="absolute rounded-full border-grey border border-1 top-0 left-0 h-full w-full z-10 pl-12 focus:shadow-xl focus:outline-none" ref={searchInput}></input>
                </div>
            </div>
            <PillDropdown>Metaverse</PillDropdown>
        </div>
    )
}

export default PropertySearch;